import { IconProps } from './types';

export function LogOut(props: IconProps) {
  const size = props.size ?? 26;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} fill="none" viewBox="0 0 26 26" {...props}>
      <path
        fill="currentColor"
        d="M19.151 16.59a.79.79 0 0 1-.565-.234.804.804 0 0 1 0-1.13l2.163-2.162-2.163-2.164a.804.804 0 0 1 0-1.13.804.804 0 0 1 1.13 0l2.728 2.729a.804.804 0 0 1 0 1.13l-2.728 2.727a.79.79 0 0 1-.565.235Z"
      />
      <path
        fill="currentColor"
        d="M21.804 13.862H10.967a.805.805 0 0 1-.799-.8c0-.436.362-.798.8-.798h10.836c.437 0 .8.362.8.799 0 .437-.363.8-.8.8Z"
      />
      <path
        fill="currentColor"
        d="M13.098 22.322c-5.487 0-9.324-3.836-9.324-9.324 0-5.488 3.837-9.324 9.325-9.324.436 0 .799.362.799.799 0 .437-.363.8-.8.8-4.55 0-7.725 3.175-7.725 7.725s3.175 7.726 7.725 7.726c.437 0 .8.362.8.799 0 .437-.363.799-.8.799Z"
      />
    </svg>
  );
}
